/* istanbul ignore file - better tested visually */

import { classNames } from '@partful/shared/lib/classNames';
import { ComponentProps, forwardRef } from 'react';
import styles from './LoadingSpinner.module.scss';

type LoadingSpinnerProps = ComponentProps<'span'>;

export const LoadingSpinner = forwardRef<HTMLSpanElement, LoadingSpinnerProps>(({ className, ...rest }, ref) => (
  <span className={classNames(styles.loader, className)} {...rest} ref={ref}>
    <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
      <circle
        stroke="var(--tenant-primary)"
        id="outer"
        cx="12"
        cy="12"
        fill="none"
        strokeLinecap="round"
        r="10"
        strokeWidth="2"
        strokeDasharray="15.707963267948966 15.707963267948966"
        transform="rotate(226.571 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 12 12; 360 12 12"
          keyTimes="0;1"
          dur="1.8s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        stroke="var(--tenant-secondary)"
        id="inner"
        cx="12"
        cy="12"
        fill="none"
        strokeLinecap="round"
        r="7"
        strokeWidth="2"
        strokeDasharray="10.995574287564276 10.995574287564276"
        strokeDashoffset="10.995574287564276"
        transform="rotate(-226.571 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 12 12;-360 12 12"
          keyTimes="0;1"
          dur="1.8s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  </span>
));
